import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixMembersUsermembersV1UserMembersUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/user-members-api',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/members/v1/user-members',
        destPath: '/v1/user-members',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/members/v1/user-members',
        destPath: '/v1/user-members',
      },
    ],
    _: [
      {
        srcPath: '/_api/members/v1/user-members',
        destPath: '/v1/user-members',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_members_user-member';

/**
 * Creates a query to retrieve a list of user members.
 *
 * The `queryUserMembers()` method builds a query to retrieve a list of user members and returns a [`UserMembersQueryBuilder`](https://dev.wix.com/docs/sdk/backend-modules/members/user-member/user-members-query-builder/ascending) object.
 *
 * The returned object contains the query definition, which is typically used to run the query using the [`find()`](https://dev.wix.com/docs/sdk/backend-modules/members/user-member/user-members-query-builder/find) method.
 *
 * You can refine the query by chaining `UserMembersQueryBuilder` methods onto the query. `UserMembersQueryBuilder` methods enable you to sort, filter, and control the results `queryUserMembers()` returns.
 *
 * `queryUserMembers()` runs with these `UserMembersQueryBuilder` defaults, which you can override:
 *
 * - [`limit(50)`](https://dev.wix.com/docs/sdk/backend-modules/members/user-member/user-members-query-builder/limit)
 */
export function queryUserMembers(payload: object): RequestOptionsFactory<any> {
  function __queryUserMembers({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.usermembers.v1.user_member',
      method: 'POST' as any,
      methodFqn: 'wix.members.usermembers.v1.UserMembers.QueryUserMembers',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixMembersUsermembersV1UserMembersUrl({
        protoPath: '/v1/user-members/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'userMembers.createdDate' },
              { path: 'userMembers.updatedDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryUserMembers;
}
